import * as React from 'react';
import './index.css';
import { reportRaptorMetrics } from '@/src/common/SLRaptor';

interface IState {
}

interface Props {
  title?: string;
  icon?: string;
  message?: string;
  dtCode?: string; //谛听码展示，调用 getDTCode/getDTCodeWithExtraInfo 方法生成即可
  retryBtnTitle?: string;
  onClickRetryBtn?: () => void;
  style404?: boolean; //废弃这个字段
}

export default class ListEmptyView extends React.Component<Props, IState> {
  // Raptor 自定义指标上报
  // https://km.sankuai.com/collabpage/1961029919
  reportMetrics() {
    const { message, dtCode } = this.props;
    let code = 'unkown';
    let dt = 'unkown';
    if (dtCode) {
      const startIndex = dtCode.indexOf('(') + 2;
      const endIndex = dtCode.indexOf('#', startIndex); // 获取'#'字符的索引
      code = dtCode.substring(startIndex, endIndex); // 使用substring方法截取字符串

      // 替换 # 成 .  否则无法上报
      dt = dtCode.replace(/#/g, '.') || 'unkown';
    }

    const tags = {
      code, dtCode: dt, msg: (message || 'unkown'), bundleName: Mach.env.bundleName || 'ListEmptyView'
    };
    reportRaptorMetrics({ appUnifiedEmptyPage: 1 }, tags, 1.0);
  }
  render() {
    const {
      icon, title, message, dtCode, retryBtnTitle, style404
    } = this.props;
    const marginTop = Mach.env.screenWidth / -1.5; // 上移图片的高度，保持文字居中

    //  上报 Raptor 自定义指标
    this.reportMetrics();

    const emptyStyle: any = {
      alignItems: 'center',
      justifyContent: 'center'
    };
    return (
      <view className="empty" style={emptyStyle}>
        <image src={icon || 'assets://common/empty_list.png'} className="empty-icon" style={{ marginTop }} />
        {!!title && <text content={title} className="empty-title" />}
        {!!message && <text content={message} className="empty-msg" />}
        {!!dtCode && <text content={dtCode} className="empty-identify-code" />}
        {!!retryBtnTitle && (
          <view className="empty-retry-wrappter">
            <text content={retryBtnTitle} className="empty-retry" onClick={() => this.props.onClickRetryBtn?.()} />
          </view>
        )}
      </view>
    );
  }
}
